import useRouter from 'hooks/useRouter';
import ChargePricingDetailView from '../../components/ChargePricingDetailView';

ChargePricingDetailScreen.propTypes = {};

function ChargePricingDetailScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const pricingId = router.query?.chargePricingId;

  return <ChargePricingDetailView pricingId={pricingId} />;
}

export default ChargePricingDetailScreen;
